import React, { useState, useEffect } from "react"
import PropTypes from 'prop-types'
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// users
import user1 from "../../../assets/images/users/avatar-1.jpg"
import { useAppSelector } from "store"
import noUser from "../../../assets/images/no_user.png"

const ProfileMenu = (props: any) => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)

  const user: any = useAppSelector(state => state.user.user);


  // useEffect(() => {
  //   if (localStorage.getItem("authUser")) {
  //     if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
  //       const obj = JSON.parse(localStorage.getItem("authUser")!)
  //       setusername(obj.displayName)
  //     } else if (
  //       process.env.REACT_APP_DEFAULTAUTH === "fake" ||
  //       process.env.REACT_APP_DEFAULTAUTH === "jwt"
  //     ) {
  //       const obj = JSON.parse(localStorage.getItem("authUser")!)
  //       setusername(obj.username)
  //     }
  //   }
  // }, [props.success])

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item mw-profile-toggle"
          id="page-header-user-dropdown"
          tag="button"
        >
          <span className="mw-profile-av">
            {(user && user.name ? user.name.charAt(0) : "U").toUpperCase()}
          </span>
          <span className="d-none d-md-inline-block ms-2 me-1">{user && user.name}</span>
          <i className="mdi mdi-chevron-down" />
        </DropdownToggle>
        <DropdownMenu end className="mw-profile-menu dropdown-menu-end">
          <div className="mw-profile-info">
            <span className="mw-profile-av lg">
              {(user && user.name ? user.name.charAt(0) : "U").toUpperCase()}
            </span>
            <div>
              <div className="mw-profile-name">{user && user.name}</div>
              <div className="mw-profile-role">{user && (user.role || user.email)}</div>
            </div>
          </div>
          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
}

const mapStatetoProps = (state: any) => {

  return {}
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)
